import { useEffect } from "react";

// Hooks
import { useAppDispatch, useAppSelector } from "app/hooks";
import useAuth from "utils/hooks/useAuth";

// Store
import { fetchPaceLabsLSPM, getPaceLabsLspm } from "store/slice/PaceLabs/paceLabsLSPM";
import { getAssessmentStatus, getIsFetchingReportStatus } from "store/slice/Pace";
import { getProject, getProjectCompanyData } from "store/slice/Project/projectData/ProjectSlice";
import { getBriefs } from "store/slice/Project/briefs/briefsSlice";
import { getInsights } from "store/slice/Project/insights/insightsSlice";
import { getSearchAis } from "store/slice/Project/searchAis/searchAisSlice";

// IMPORTANT
// Avoid fetching LSPM request along with Asssessment or Report Status it causes 500 error.
// To avoid this here we are checking isFetchingReportStatus and isFetchingAssessment

const useGetPersonLSPM = (requestPace = false, shouldAvoidRequest = [false]) => {
    const dispatch = useAppDispatch();
    const { person_id } = useAuth();

    const {
        status: LSPMRequestInfo,
        paceDataStatus: LSPMRequestPaceInfo,
        data: LSPMData,
    } = useAppSelector(getPaceLabsLspm);

    const isFetchingReportStatus = useAppSelector(getIsFetchingReportStatus);
    const isFetchingAssessment = useAppSelector(getAssessmentStatus);
    const { status: isFetchingProject } = useAppSelector(getProject);
    const { status: isFetchingInsight } = useAppSelector(getInsights);
    const { status: isFetchingBrief } = useAppSelector(getBriefs);
    const { status: isFetchingSearchAi } = useAppSelector(getSearchAis);
    const { status: isFetchingCompany } = useAppSelector(getProjectCompanyData);

    useEffect(() => {
        if (!person_id) return;

        const fetchLSPMData = () => {
            try {
                dispatch(fetchPaceLabsLSPM({ person_id: person_id, pace: requestPace }));
            } catch (error) {
                console.error(error);
            }
        };

        if (
            requestPace === true &&
            LSPMRequestPaceInfo === "pristine" &&
            isFetchingReportStatus === "done" &&
            isFetchingAssessment !== "fetching" &&
            isFetchingProject !== "fetching" &&
            isFetchingInsight !== "fetching" &&
            isFetchingBrief !== "fetching" &&
            isFetchingSearchAi !== "fetching" &&
            isFetchingCompany !== "fetching"
        ) {
            fetchLSPMData();
        }

        if (
            requestPace === false &&
            LSPMRequestInfo === "pristine" &&
            isFetchingReportStatus === "done" &&
            !shouldAvoidRequest.every((condition) => condition) &&
            isFetchingAssessment !== "fetching" &&
            isFetchingProject !== "fetching" &&
            isFetchingInsight !== "fetching" &&
            isFetchingBrief !== "fetching" &&
            isFetchingSearchAi !== "fetching" &&
            isFetchingCompany !== "fetching"
        ) {
            fetchLSPMData();
        }
    }, [
        LSPMRequestInfo,
        LSPMRequestPaceInfo,
        dispatch,
        isFetchingAssessment,
        isFetchingBrief,
        isFetchingCompany,
        isFetchingInsight,
        isFetchingProject,
        isFetchingReportStatus,
        isFetchingSearchAi,
        person_id,
        requestPace,
        shouldAvoidRequest,
    ]);
};

export default useGetPersonLSPM;
